var React = require('react');

function Monitoring (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15 12a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1V3a1 1 0 1 1 2 0v9h13zM11.267 2H15v3.78l-1.174-1.19-4.05 4.049a1 1 0 0 1-1.413 0l-1.42-1.42-2.68 2.679a.997.997 0 0 1-1.414 0 .999.999 0 0 1 0-1.414l3.387-3.386a.996.996 0 0 1 1.414 0l1.42 1.42 3.35-3.351L11.267 2z"}));
}

Monitoring.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = Monitoring;

Monitoring.default = Monitoring;
